module.exports = __webpack_public_path__ + "static/img/picture10.1c2edd95.png";